import { Field } from 'formik';
import styled, { css } from 'styled-components/macro';

import CheckmarkWhiteSvg from 'assets/icons/office/checkmarkWhiteSvg.svg';

export const Input = styled(Field)`
  position: absolute;

  opacity: 0;
`;

export const CheckboxWrapper = styled.label<{
  weekly?: boolean;
  CheckmarkWhiteSvg?: string;
  disabled?: boolean;
}>`
  position: relative;

  display: flex;
  align-items: center;
  padding: ${({ theme, weekly }) => (weekly ? theme.spacing.one_2 : theme.spacing.zero_2)};
  padding-left: ${({ theme, weekly }) => (weekly ? theme.spacing.two_2 : theme.spacing.one_2)};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xs};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  span:after {
    display: none;

    width: 100%;
    height: 100%;

    background-image: url(${CheckmarkWhiteSvg});
    background-repeat: no-repeat;
    background-position: center;
  }

  input:checked ~ span {
    border: none;
  }

  input:checked:disabled ~ span {
    background-color: ${({ theme }) => theme.colors.black_20};
  }

  input:checked:not(:disabled) ~ span {
    background-color: ${({ theme }) => theme.colors.primary_80};
  }

  input:checked ~ span:after {
    display: block;
  }

  input:disabled ~ span {
    background-color: ${({ theme }) => theme.colors.black_5};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    ${({ weekly }) =>
      weekly &&
      css`
        padding-left: 1.8rem;
      `}
  }
`;

export const CheckBox = styled.span<{ weekly?: boolean }>`
  position: absolute;
  left: ${({ weekly }) => (weekly ? '12px' : '0')};

  width: 1rem;
  height: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.black_40};
  border-radius: 4px;

  background-color: ${({ theme }) => theme.colors.white};
  &:after {
    position: absolute;

    display: block;

    content: '';
  }
`;

export const Asterisk = styled.i`
  color: ${({ theme }) => theme.colors.negative_dark};
  font-style: normal;
`;
